import { render, staticRenderFns } from "./campaign_table.vue?vue&type=template&id=0e8a9000&scoped=true"
import script from "./campaign_table.vue?vue&type=script&lang=ts"
export * from "./campaign_table.vue?vue&type=script&lang=ts"
import style0 from "./campaign_table.vue?vue&type=style&index=0&id=0e8a9000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a9000",
  null
  
)

export default component.exports